module.exports = __webpack_public_path__ + "static/media/IMG_20190615_184528.91ec83d8.jpg";